import {TrRevision} from '@/domain/models/TrRevision';
import {httpGet} from '@/shared/api/serve';

type TtRevisionsParams = {
  initUuid?: string | null;
} & Pick<TrRevision, 'uuid'>;

type TrRevisionsResponseDto = {
  keys: Record<string, string>;
  lang: string;
};

export async function rtRevisions({uuid, initUuid}: TtRevisionsParams) {
  const params = new URLSearchParams({
    revision_uuid: uuid,
  });

  if (initUuid) {
    params.append('init_uuid', initUuid);
  }

  const response = await httpGet<TrRevisionsResponseDto>(
    `/tr_revisions?${params}`
  );
  return response.data.result;
}
